import type { FC } from 'react';
import { useTheme } from 'styled-components';
import { useButtonAction } from '@/modules/promo';
import { Loader } from '../Loader';

import { type IScCTAButton, ScCTAButton } from './styled';

interface ICTAButton extends IScCTAButton {
  text: string;
  afterRegistrationRedirect?: string;
}
export const CTAButton: FC<ICTAButton> = ({
  text,
  borderRadius = '12px',
  background,
  color,
  afterRegistrationRedirect,
  movingBlink,
}) => {
  const { buttonAction, isLoading } = useButtonAction(
    afterRegistrationRedirect
  );
  const { green2Color, whiteColor } = useTheme();

  return (
    <ScCTAButton
      disabled={isLoading}
      {...buttonAction}
      background={background || green2Color}
      borderRadius={borderRadius}
      color={color || whiteColor}
      movingBlink={movingBlink}
    >
      {isLoading ? <Loader /> : text}
    </ScCTAButton>
  );
};
